import axios from 'api/axiosInstances/axiosInstance';

export const removeUserBillingAccount = (billingAccount) => {
  return axios.delete(`/users/billingaccounts/${billingAccount}`);
};
